export default "__VITE_ASSET__12e522b8__"